export const SET_FLEET = 'fleet/SET_FLEET'
export const RESET_FLEET = 'fleet/RESET_FLEET'
